import { FC } from 'react'
import { cn } from '../../lib/utils'

interface AcleraWordmarkProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClasses = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-3xl',
} as const

export const AcleraWordmark: FC<AcleraWordmarkProps> = ({ size = 'sm', className }) => (
  <span className={cn('font-display font-semibold tracking-tight select-none', sizeClasses[size], className)}>
    <span className="text-clinical-teal">Aclera</span>
    <span className="text-clinical-amber ml-0.5">AI</span>
  </span>
)
